import Header from "components/common/Header/Header";
import SideBarNew from "components/common/SideBar/SideBarNew";
import { LoginContext } from "helpers/LoginContext";
import React, { useContext, useMemo } from "react";
import { connect } from "react-redux";
import { classNames } from "Utils/utils";
import { useNavigate } from "react-router";
import {
  getParticipantLabel,
  shouldShowCosAlliedHealthNav,
} from "Constants/constant";
import { getSpSetting } from "store/selector/sp.selector";
import RocIcon from "assets/reporting-icons/roc-reports.png";
import CaseNotesIcon from "assets/reporting-icons/casenote.png";
import ComplaintIcon from "assets/reporting-icons/complaint.png";
import CosIcon from "assets/reporting-icons/cos.png";
import FeedbackIcon from "assets/reporting-icons/feedback-reports.png";
import ParticipantExpIcon from "assets/reporting-icons/participant-expiring-doc.png";
import ParticipantListIcon from "assets/reporting-icons/participant-list-report.png";
import TimesheetIcon from "assets/reporting-icons/timsheet-report.png";
import WeeklyRocIcon from "assets/reporting-icons/weekly-roc.png";
import WorkerExpIcon from "assets/reporting-icons/worker-expiring-doc.png";
import WorkerListIcon from "assets/reporting-icons/worker-list.png";
import KypIcon from "assets/reporting-icons/kyp.png"
import IncidentIcon from "assets/reporting-icons/incident-report.png";
import DetailedInvoiceIcon from "assets/reporting-icons/Detailed-Invoicing.png";
import SummaryInvoiceIcon from "assets/reporting-icons/summary-invoice.png";
import FundingIcon from "assets/reporting-icons/funding-reports.png";
import { RiSkull2Line } from "react-icons/ri";
import { TbReport } from "react-icons/tb";
import { HiOutlineClock } from "react-icons/hi";
const Reporting = (props) => {
  const { settings } = props;
  const { sideBarPadding } = useContext(LoginContext);
  const navigate = useNavigate();
  const participantLabelPlural = getParticipantLabel(settings?.care_sector, true);
  const showCosReports = shouldShowCosAlliedHealthNav(settings?.care_sector);

  const cards = useMemo(() => {
    const allCards = [
    {
      icon: (
        <HiOutlineClock className="h-8 w-8 text-white" />
      ),
      name: "Export History",
      color: "bg-indigo-50",
      shadow: "hover:shadow-lg hover:shadow-indigo-100 hover:border-indigo-100",
      href: "reporting/export-history",
      bgColor: "#4F46E5",
    },
    {
    
      icon:<img src={RocIcon} alt="roc weekly report"/>,
      name: "ROC Report",
      color: "bg-green-50",
      shadow: "hover:shadow-lg hover:shadow-green-100 hover:border-green-100",
      href: "reporting/roc-reports",
      bgColor: "#31BB79",
    },
    {
     
      name: "ROC Weekly Report",
      color: "bg-green-50",
      shadow: "hover:shadow-lg hover:shadow-green-100 hover:border-green-100",
      href: "reporting/roc-weekly-reports",
      bgColor: "#795aaa",
      icon:<img src={WeeklyRocIcon} alt="roc weekly report"/>
    },
    {
      
      icon:<img src={TimesheetIcon} alt="timsheet report"/>,
      name: "Timesheet Report",
      color: "bg-yellow-50",
      shadow: "hover:shadow-lg hover:shadow-yellow-100 hover:border-yellow-100",
      href: "reporting/timesheet-reports",
      bgColor: "#29C3E1",
    },
    {
      icon:<img src={TimesheetIcon} alt="Payroll report"/>,
      name: "Payroll Report",
      color: "bg-yellow-50",
      shadow: "hover:shadow-lg hover:shadow-yellow-100 hover:border-yellow-100",
      href: "reporting/xero-timesheet-export-reports",
      bgColor: "#0EA5A4",
    },
    

{
     
      icon:<img src={FeedbackIcon} alt="feedback report"/>,
      name: "Feedback Report",
      color: "bg-purple-50",
      shadow: "hover:shadow-lg hover:shadow-purple-100 hover:border-purple-100",
      href: "reporting/feedback-reports",
      bgColor: "#eEA1E1",
    },
    {
     
      icon:<img src={ComplaintIcon} alt="complaints report"/>,
      name: "Complaints Report",
      color: "bg-blue-50",
      shadow: "hover:shadow-lg hover:shadow-blue-100 hover:border-blue-100",
      href: "reporting/complaints-reports",
      bgColor: "#FFCC00",
    },
    {
      icon:<img src={ParticipantListIcon} alt="participant list report"/>,
      name: `${participantLabelPlural} List Report`,
      color: "bg-fuchsia-50",
      shadow:
        "hover:shadow-lg hover:shadow-fuchsia-100 hover:border-fuchsia-100",
      href: "reporting/participant-listing-reports",
      bgColor: "#4a101F",
    },
    {
    
        icon:<img src={KypIcon} alt="cos report"/>,
      name: "KYP Report",
      color: "bg-blue-50",
      shadow: "hover:shadow-lg hover:shadow-blue-100 hover:border-blue-100",
      href: "reporting/kyp-reports",
      bgColor: "#89A55F",
    },
    {
      icon:<img src={ParticipantExpIcon} alt="participant expiring document report"/>,
      name: `${participantLabelPlural} Expiring documents Report`,
      color: "bg-blue-50",
      shadow: "hover:shadow-lg hover:shadow-blue-100 hover:border-blue-100",
      href: "reporting/participant-expiring-documents-reports",
      bgColor: "#15939E",
    },
    {
    
      icon:<img src={WorkerListIcon} alt="Worker report"/>,
      name: "Worker List Report",
      color: "bg-blue-50",
      shadow: "hover:shadow-lg hover:shadow-blue-100 hover:border-blue-100",
      href: "reporting/worker-list-reports",
      bgColor: "#44456E",
    },
    {
    
      icon:<img src={WorkerExpIcon} alt="worker expiring document report"/>,
      name: "Worker Expiring documents Report",
      color: "bg-blue-50",
      shadow: "hover:shadow-lg hover:shadow-blue-100 hover:border-blue-100",
      href: "reporting/worker-expiring-documents-reports",
      bgColor: "#513f4f",
    },
 
    {
    
      icon:<img src={CaseNotesIcon} alt="casenote report"/>,
      name: `${participantLabelPlural} Case Notes Report`,
      color: "bg-blue-50",
      shadow: "hover:shadow-lg hover:shadow-blue-100 hover:border-blue-100",
      href: "reporting/case-notes-reports",
      bgColor: "#1f2d4f",
    },
    {
    
      name: "Incident Report",
      color: "bg-red-50",
      shadow: "hover:shadow-lg hover:shadow-red-100 hover:border-red-100",
      href: "reporting/incident-reports",
      bgColor: "",
      icon:<img src={IncidentIcon} alt="timsheet report"/>,
    },
    {
      name: "Incident Management Report",
      color: "bg-red-50",
      shadow: "hover:shadow-lg hover:shadow-red-100 hover:border-red-100",
      href: "reporting/incident-management-reports",
      bgColor: "#DC2626",
      icon:<img src={IncidentIcon} alt="incident management report"/>,
    },
    {
      icon: (
          <RiSkull2Line className='w-[50px] h-[50px] px-2 py-2 text-red-500 rounded-md' />
        ),
      name: "Risk Assessment Report",
      color: "bg-blue-50",
      shadow: "hover:shadow-lg hover:shadow-blue-100 hover:border-blue-100",
      href: "reporting/risk-assessment-reports",
      bgColor: "#FEF2F2",
 

    },
    {
      
      name: "COS Funding Report",
      color: "bg-blue-50",
      shadow: "hover:shadow-lg hover:shadow-blue-100 hover:border-blue-100",
      href: "reporting/funding-reports",
      bgColor: "",
            icon:<img src={FundingIcon} alt="funding report"/>,
      cosOnly: true,

    },

 
    {

      icon:<img src={CosIcon} alt="cos report"/>,
      name: "COS Case Note Report",
      color: "bg-blue-50",
      shadow: "hover:shadow-lg hover:shadow-blue-100 hover:border-blue-100",
      href: "reporting/cos-reports",
      bgColor: "	#b061ff",
      cosOnly: true,
    },
    {
 
      name: "Detailed Invoicing Report",
      color: "bg-blue-50",
      shadow: "hover:shadow-lg hover:shadow-blue-100 hover:border-blue-100",
      href: "reporting/detailed-invoicing-reports",
 
      icon:<img src={DetailedInvoiceIcon} alt="detailed invoice report"/>,
    },
    {
  
      name: "Summary Invoicing Report",
      color: "bg-blue-50",
      shadow: "hover:shadow-lg hover:shadow-blue-100 hover:border-blue-100",
      href: "reporting/summary-invoicing-reports",
  
      icon:<img src={SummaryInvoiceIcon} alt="summary invoice report"/>,

    },
       {
  
      name: "NDIS Claims Report",
      color: "bg-blue-50",
      shadow: "hover:shadow-lg hover:shadow-blue-100 hover:border-blue-100",
      href: "reporting/ndis-claims-reports",
      bgColor: "#FEF2F2",
    icon: (
          <TbReport className='w-[50px] h-[50px] px-2 py-2 text-[#AB4571] rounded-md' />
        ),

    },
 
  ];

    return allCards.filter(
      (card) => !card.cosOnly || showCosReports
    );
  }, [participantLabelPlural, showCosReports]);

  return (
    <div className='min-h-full pb-2 '>
      <SideBarNew />
      <div
        className={`duration-300 flex flex-col ${
          sideBarPadding ? "lg:pl-[4rem]" : "lg:pl-64"
        }`}
      >
        <main className='flex-1 relative'>
          <Header title='Reporting Dashboard' />
          <div className='w-full min-h-full px-3'>
            <div
              className={`grid mt-8  gap-5 ${
                // roleAccess([USER_ROLE.Sp_manager])
                //   ? "grid-cols-2 sm:grid-cols-1 lg:grid-cols-2 capitalize"
                //   :
                "sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 capitalize"
              }`}
            >
              {" "}
              {cards.map((item, index) => (
                <div
                  onClick={() => {
                    if (item.href) navigate(`/${item.href}`);
                  }}
                  role='button'
                  tabIndex={0}
                  key={index}
                  className='cursor-pointer relative rounded-lg border border-[] bg-white p-1 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500 capitalize'
                >
                  <div
                    className={classNames(
                      "flex-shrink-0 flex items-center justify-center w-16 h-12 py-8 text-white text-sm font-medium rounded-sm"
                    )}
                    style={{ backgroundColor: `${item.bgColor || ""}` }}
                  >
                    {item.icon}
                  </div>
                  <div className='flex-1 min-w-0'>
                    <div className='focus:outline-none'>
                      <span className='absolute inset-0' aria-hidden='true' />
                      <p className='text-sm font-medium text-gray-900 mt-3'>
                        {item.name}
                      </p>
                    </div>
                  </div>
                </div>
             
              ))}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  settings: getSpSetting(state),
});

export default connect(mapStateToProps)(Reporting);

